var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gastos"},[_c('notas-form',{attrs:{"proyectoId":_vm.id_proyecto,"notaProp":_vm.nota}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }